import { dashboardConfigKey, useDashboardConfig } from '../../queries/useDashboardConfig';
import { currentUserKey, useCurrentUser } from '../../queries/useCurrentUser';
import { teamsKey, useTeams } from '../../queries/useTeams';
import { leadTypesKey, useLeadTypes } from '../../hooks/useLeadTypes';
import { useSWRConfig } from 'swr';

export const useQueryState = () => {
  const { mutate } = useSWRConfig();

  const {
    data: dashboardConfig,
    error: dashboardConfigError,
    isLoading: dashboardConfigLoading
  } = useDashboardConfig();

  const {
    data: currentUser,
    error: currentUserError,
    isLoading: currentUserLoading
  } = useCurrentUser();

  // Non-blocking: mounting these starts the fetches at app boot so the
  // caches are warm by the time pages need them, but they don't gate render.
  const { data: teams } = useTeams();
  const { leadTypes } = useLeadTypes();

  // Only /is-enabled (dashboardConfig) and /self (currentUser) gate the app.
  // Teams, lead-types and preferences load in the background — pages handle
  // their own loading/empty states and failures surface per-view.
  const queryError = dashboardConfigError || currentUserError;
  const queryLoading = dashboardConfigLoading || currentUserLoading;

  const isDataReady = !!(dashboardConfig && currentUser);

  const revalidateAll = () => {
    mutate(dashboardConfigKey);
    mutate(currentUserKey);
    mutate(teamsKey);
    mutate(leadTypesKey);
  };

  return {
    dashboardConfig,
    currentUser,
    teams,
    leadTypes,
    queryError,
    queryLoading,
    isDataReady,
    revalidateAll
  };
};
